$(document).ready(function($){

	const _window = $(window);
	const windowWidth = _window.width();
	const windowHeight = _window.height();

	const html = $('html');
	const body = $('body');

	const responsive = 900 < windowWidth  ? false : true;
	const responsiveMobile = windowWidth <= 900;

	// 2.0 APP INIT
	function appInit() {
		initForms();
		initRetina();
	}
	appInit();

	// 3.0 UTILITY FUNCTIONS
	function initForms(){
		let inputs = $(`.field input[type="text"],
			.field input[type="email"], 
			.field input[type="tel"],
			.field input[type="url"],
			.field input[type="password"],
			.field textarea`);

		inputs.each(function() {
			let _this = $(this);

			if(_this.val().length > 0){
				_this.closest('.field').addClass('has_value');
			}
		}).blur(function() {
			let _this = $(this);

			_this.val() 
				? _this.closest('.field').addClass('has_value')
				: _this.closest('.field').removeClass('has_value');
		});
	}

	function initRetina(){
		if(window.devicePixelRatio > 1){
			html.addClass('is_retina');
		}
		if(responsiveMobile){
			$('img[data-responsive-mobile]').each(function() {
				var img = $(this);
				if(img.attr('responsive-mobile') != ''){
					img.attr('src',img.attr('data-mobile'))
				}
			});
		}
	}

	// 6.0 SCROLL ANIMATIONS USING ANIMATE.CSS

	// Check if element is scrolled into view
	function isScrolledIntoView(elem) {
		var docViewTop = $(window).scrollTop();
		var docViewBottom = docViewTop + $(window).height();

		var elemTop = $(elem).offset().top;
		var elemBottom = elemTop + $(elem).height() - 150;

		return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop)) || (elemBottom <= docViewBottom);
	}

	// simple subtle scroll affect as found on clara.co
	$(window).scroll(function() {
		$('.subtle-animation').each(function() {
			if (isScrolledIntoView(this) === true) {
				$(this).addClass(`in-view`);
			}
		});
	});
	setTimeout(function(){
		$('.subtle-animation').each(function() {
			if (isScrolledIntoView(this) === true) {
				$(this).addClass(`in-view`);
			}
		});
	}, 100);

	function displayNavigation() {
		const homepageNavigation = $('.section-navigation-bar').first();
		if (homepageNavigation.length) {
			const isStuck = homepageNavigation[0].getBoundingClientRect().top <= 0;
			const wasStuck = homepageNavigation.hasClass('is-stuck');
			homepageNavigation.toggleClass('is-stuck', isStuck);
			if (isStuck !== wasStuck) updateAudienceIndicator(homepageNavigation.find('[data-homepage-navigation]').first());
			$('.sticky-navigation').css('opacity', isStuck ? 1 : 0);
			return;
		}

		const selfLogo = $('.self-logo').first();
		if (!selfLogo.length) return;
		const headerHeight = selfLogo.height() + selfLogo.offset().top + 5;
		const scrollFixed = $(window).scrollTop() / headerHeight - 1;
		$('.sticky-navigation').css({
			'opacity': scrollFixed
		});
	}
    if($('.self-logo').length || $('.section-navigation-bar').length){
        $(window).scroll(function(){
            displayNavigation($(this).scrollTop())
        });
        setTimeout(function(){
            // fixes inconsistent display on page load since mid-page can show scrollTop 0
            displayNavigation();
        }, 100);
    }

	function homepageSectionsFor(audience) {
		return $('[data-homepage-section]').filter(function() {
			const sectionCategory = String($(this).attr('data-section-category') || '');
			return !sectionCategory || sectionCategory === audience;
		});
	}

	function updateAudienceIndicator(navigation) {
		const audiences = navigation.find('.homepage-navigation__audiences')[0];
		const activeButton = navigation.find('[data-audience].active')[0];
		if (!audiences || !activeButton) return;
		const audienceRect = audiences.getBoundingClientRect();
		const buttonRect = activeButton.getBoundingClientRect();
		audiences.style.setProperty('--audience-indicator-width', buttonRect.width + 'px');
		audiences.style.setProperty('--audience-indicator-x', buttonRect.left - audienceRect.left - audiences.clientLeft + 'px');
	}

	let homepageAudienceTransitionId = 0;
	let releaseHomepageHeightLock;
	const homepageAudienceViewportStates = new Map();

	function restoreHomepageScrollPosition(scrollTop) {
		const root = document.documentElement;
		const previousScrollBehavior = root.style.scrollBehavior;
		root.style.scrollBehavior = 'auto';
		window.scrollTo(window.pageXOffset, scrollTop);
		root.style.scrollBehavior = previousScrollBehavior;
	}

	function captureHomepageViewportState(preferredAnchor) {
		const navigationSection = $('.section-navigation-bar').first()[0];
		const referenceTop = navigationSection ? navigationSection.getBoundingClientRect().bottom : 0;
		const visibleSections = $('[data-homepage-section]').filter(':visible').toArray();
		let anchorElement = preferredAnchor && $(preferredAnchor).is(':visible') ? preferredAnchor : null;

		if(!anchorElement) {
			const currentSection = visibleSections.find(function(section) {
				const rect = section.getBoundingClientRect();
				return rect.top <= referenceTop && rect.bottom > referenceTop;
			});
			const sharedSections = visibleSections.filter(function(section) {
				return !String($(section).attr('data-section-category') || '');
			});

			if(currentSection && !String($(currentSection).attr('data-section-category') || '')) {
				anchorElement = currentSection;
			} else {
				anchorElement = sharedSections.find(function(section) {
					return section.getBoundingClientRect().bottom > referenceTop;
				}) || sharedSections[sharedSections.length - 1] || currentSection || null;
			}
		}

		return {
			scrollTop: window.pageYOffset,
			anchorElement: anchorElement,
			anchorTop: anchorElement ? anchorElement.getBoundingClientRect().top : null
		};
	}

	function restoreHomepageViewportState(viewportState) {
		if(!viewportState) return;

		if(viewportState.anchorElement && $(viewportState.anchorElement).is(':visible')) {
			const currentAnchorTop = viewportState.anchorElement.getBoundingClientRect().top;
			restoreHomepageScrollPosition(window.pageYOffset + currentAnchorTop - viewportState.anchorTop);
			return;
		}

		restoreHomepageScrollPosition(viewportState.scrollTop);
	}

	function lockHomepageDocumentHeight() {
		if(releaseHomepageHeightLock) releaseHomepageHeightLock();

		const previousMinHeight = document.body.style.minHeight;
		const previousOverflowAnchor = document.documentElement.style.overflowAnchor;
		const lockedHeight = Math.max(
			document.documentElement.scrollHeight,
			document.body.scrollHeight,
			window.pageYOffset + window.innerHeight
		);
		let isReleased = false;

		document.body.style.minHeight = lockedHeight + 'px';
		document.documentElement.style.overflowAnchor = 'none';
		const release = function() {
			if(isReleased) return;
			isReleased = true;
			document.body.style.minHeight = previousMinHeight;
			document.documentElement.style.overflowAnchor = previousOverflowAnchor;
			if(releaseHomepageHeightLock === release) releaseHomepageHeightLock = null;
		};
		releaseHomepageHeightLock = release;
		return release;
	}

	function animateHomepageAudience(audience, viewportState, releaseHeightLock) {
		const transitionId = ++homepageAudienceTransitionId;
		const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		const enteringSections = homepageSectionsFor(audience).filter(function() {
			return $(this).closest('.section-portfolio, .section-advisory').length;
		});
		const enteringWrappers = enteringSections.closest('.section-portfolio, .section-advisory');

		$('.section-portfolio, .section-advisory').removeClass('homepage-section-entering');
		if(!enteringWrappers.length) {
			if(releaseHeightLock) {
				const releaseViewportState = captureHomepageViewportState(viewportState && viewportState.anchorElement);
				releaseHeightLock();
				restoreHomepageViewportState(releaseViewportState);
			}
			return;
		}

		const scrollTarget = enteringWrappers[0];
		let fallbackTimer;
		let hasFinished = false;

		function finishTransition() {
			if(hasFinished) return;
			hasFinished = true;
			clearTimeout(fallbackTimer);
			scrollTarget.removeEventListener('animationend', onAnimationEnd);
			enteringWrappers.removeClass('homepage-section-entering');

			if(transitionId !== homepageAudienceTransitionId) {
				if(releaseHeightLock) releaseHeightLock();
				return;
			}

			if(releaseHeightLock) {
				const releaseViewportState = captureHomepageViewportState(viewportState && viewportState.anchorElement);
				releaseHeightLock();
				restoreHomepageViewportState(releaseViewportState);
				requestAnimationFrame(function() {
					restoreHomepageViewportState(releaseViewportState);
				});
			}
		}

		function onAnimationEnd(event) {
			if(event.target === scrollTarget && event.animationName === 'homepage-section-fade-in') {
				finishTransition();
			}
		}

		if(prefersReducedMotion) {
			finishTransition();
			return;
		}

		// Force a new animation even when the visitor quickly toggles back.
		void scrollTarget.offsetWidth;
		scrollTarget.addEventListener('animationend', onAnimationEnd);
		enteringWrappers.addClass('homepage-section-entering');
		fallbackTimer = setTimeout(finishTransition, 900);
	}

	function setHomepageAudience(audience) {
		const navigation = $('[data-homepage-navigation]').first();
		const categories = new Map();

		navigation.find('[data-audience]').each(function() {
			const isActive = $(this).attr('data-audience') === audience;
			$(this).toggleClass('active', isActive).attr('aria-pressed', String(isActive));
		});

		$('[data-homepage-section]').each(function() {
			const section = $(this);
			const sectionCategory = String(section.attr('data-section-category') || '');
			const isVisible = !sectionCategory || sectionCategory === audience;
			section.toggleClass('homepage-section-hidden', !isVisible).attr('aria-hidden', String(!isVisible));
			section.find('[data-filter-item]').removeClass('hidden');

			if(!isVisible) return;

			const action = section.attr('data-subcategory-action') || 'filter';
			section.find('[data-section-categories] [data-category]').each(function() {
				const category = String($(this).attr('data-category') || '');
				const navigationAudience = String($(this).attr('data-navigation-audience') || '');
				if(!category || categories.has(category) || (navigationAudience && navigationAudience !== audience)) return;

				const anchorSelector = '[data-section-anchor="' + category + '"]';
				const anchor = section.filter(anchorSelector).add(section.find(anchorSelector)).first();
				categories.set(category, {
					label: $(this).text().trim(),
					action: action,
					target: anchor.length ? anchor.attr('id') : ''
				});
			});
		});

		const categoryBar = navigation.find('[data-homepage-categories]').empty();
		categories.forEach(function(item, category) {
			$('<button type="button" class="homepage-navigation__category" aria-pressed="false"></button>')
				.attr('data-category', category)
				.attr('data-category-action', item.action)
				.attr('data-category-target', item.target)
				.text(item.label)
				.appendTo(categoryBar);
		});

		const firstCategory = categoryBar.find('[data-category]').first();
		if(firstCategory.length) activateHomepageSubcategory(firstCategory, false);

		const activeLabel = navigation.find('[data-audience].active').text().trim();
		navigation.find('[data-homepage-navigation-status]').text(activeLabel + ' selected');
		updateAudienceIndicator(navigation);
		displayNavigation();
	}

	function activateHomepageSubcategory(button, shouldNavigate) {
		const navigation = $('[data-homepage-navigation]').first();
		const audience = navigation.find('[data-audience].active').attr('data-audience');
		const category = String(button.attr('data-category') || '');
		const action = button.attr('data-category-action') || 'filter';

		navigation.find('[data-category]').removeClass('active').attr('aria-pressed', 'false');
		button.addClass('active').attr('aria-pressed', 'true');

		if(action === 'filter') {
			const filterSections = homepageSectionsFor(audience).filter('[data-subcategory-action="filter"]');
			filterSections.each(function() {
				$(this).find('[data-filter-item]').each(function() {
					const itemCategory = String($(this).attr('data-category') || '');
					$(this).toggleClass('hidden', category !== 'all' && itemCategory !== category);
				});
			});

			if(shouldNavigate && filterSections.length) {
				requestAnimationFrame(function() {
					const target = filterSections.first()[0];
					const navigationSection = $('.section-navigation-bar').first()[0];
					const navigationOffset = navigationSection ? navigationSection.getBoundingClientRect().height + 16 : 0;
					const targetTop = window.pageYOffset + target.getBoundingClientRect().top - navigationOffset;
					window.scrollTo({
						top: Math.max(0, targetTop),
						behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
					});
				});
			}
		}

		if(action === 'anchor' && shouldNavigate) {
			const targetId = button.attr('data-category-target');
			const target = targetId ? document.getElementById(targetId) : null;
			if(target) {
				target.scrollIntoView({
					behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
					block: 'start'
				});
			}
		}

		navigation.find('[data-homepage-navigation-status]').text(button.text().trim() + ' selected');
	}

	$(document).on('click', '[data-homepage-navigation] [data-audience]', function() {
		const audience = $(this).attr('data-audience');
		const navigation = $('[data-homepage-navigation]').first();
		const currentAudience = navigation.find('[data-audience].active').attr('data-audience');
		if(audience === currentAudience) return;
		const currentViewportState = captureHomepageViewportState();
		homepageAudienceViewportStates.set(currentAudience, currentViewportState);
		const viewportState = homepageAudienceViewportStates.get(audience) || currentViewportState;
		const releaseHeightLock = lockHomepageDocumentHeight();
		setHomepageAudience(audience);
		restoreHomepageViewportState(viewportState);
		requestAnimationFrame(function() {
			restoreHomepageViewportState(viewportState);
			homepageAudienceViewportStates.set(audience, captureHomepageViewportState(viewportState.anchorElement));
		});
		animateHomepageAudience(audience, viewportState, releaseHeightLock);
	});

	$(document).on('click', '[data-homepage-navigation] [data-category]', function() {
		activateHomepageSubcategory($(this), true);
	});

	function initHomepageNavigation() {
		const navigation = $('[data-homepage-navigation]').first();
		if(!navigation.length) return;
		const activeAudience = navigation.find('[data-audience].active').attr('data-audience');
		setHomepageAudience(activeAudience || navigation.attr('data-default-audience') || 'venture-capital');
	}

	initHomepageNavigation();
	if (document.fonts && document.fonts.ready) {
		document.fonts.ready.then(function() {
			updateAudienceIndicator($('[data-homepage-navigation]').first());
		});
	}
	$(window).on('resize', function() {
		updateAudienceIndicator($('[data-homepage-navigation]').first());
		displayNavigation();
	});
	$(document).on('shopify:section:load shopify:section:reorder', function() {
		initHomepageNavigation();
	});
});
